import React,{Component} from "react";
import './UnipayBar.css';
import {Link} from "react-router-dom";
import {connect}  from  "react-redux";
// import MenuIcon from '@material-ui/icons/Menu';

 class UnipayBar extends Component{
constructor(props){
 super(props)
   this.state={
        //   dashboardimg:SrcDashboard,
          dashcolor:'#707070',
        //   trendsimg:SrcTrends,
          trendscolor:'#707070',
        //   toolsimg:SrcTools,
          toolscolor:'#707070',
        //   helpimg:SrcHelp,
          helpcolor:'#707070',
        //   profileimg:SrcProfile,
          profilecolor:'#707070',
          acquirer:'#707070',
          historical:'#707070',
          emi:'#707070',
          supportmodule:'#707070',
          invoice:'#707070',
          size:'12px',
          weight:600,
          bottomPopupMenu:false,
          Sidebar:false
  
               }
                    };

                    componentDidMount()
                    {
                       let sp = window.location.pathname.split("/");
                       if(window.location.pathname.split("/")[2]=="dashboard" || window.location.pathname.split("/")[2] =='DashboardDetails'){this.dash()}
                     
                        else if(window.location.pathname.split("/")[2]=='settlement'){this.trends()}
                     
                       else if(window.location.pathname.split("/")[2] =='sale'){this.tools()}
                      
                       else if(window.location.pathname.split("/")[2] =='transaction-report'){this.help()}

                       else if(window.location.pathname.split("/")[2] =='acquirer-report'){this.acquirer()}

                       else if(window.location.pathname.split("/")[2] =='transaction-report-history'){this.historical()}

                       else if(window.location.pathname.split("/")[2] =='emi-report'){this.emireport()}

                       else if(window.location.pathname.split("/")[2] =='support-module'){this.supportmodule()}
                      
                       else if(window.location.pathname.split("/")[2] =='invoice'){this.invoice()}
                         
                    }

                    acquirer =() =>{
                      this.setState({
                        acquirer:'rgb(44, 11, 249)'
                  
                      })
                    }


                    historical =() =>{
                      this.setState({
                        historical:'rgb(44, 11, 249)'
                  
                      })
                    }



                    emireport =() =>{
                      this.setState({
                        emi:'rgb(44, 11, 249)'
                  
                      })
                    }



                    supportmodule =() =>{
                      this.setState({
                        supportmodule:'rgb(44, 11, 249)'
                  
                      })
                    }

                    supportmodule =() =>{
                      this.setState({
                        invoice:'rgb(44, 11, 249)'
                  
                      })
                    }

                    dash =() =>{
                      this.setState({
                        dashcolor:'rgb(44, 11, 249)',
                        trendscolor:'#707070',
                        toolscolor:'#707070',
                        helpcolor:'#707070',
                        profilecolor:'#707070',
                      })
                        this.props.UnipayParentCallback("dash");
                    }
                 

                    trends =() =>{
                      this.setState({
                        dashcolor:'#707070',
                        trendscolor:'rgb(44, 11, 249)',
                        toolscolor:'#707070',
                        helpcolor:'#707070',
                        profilecolor:'#707070',
                      })
                        this.props.UnipayParentCallback("settlement");
                    }
                    tools =() =>{
                      this.setState({
                        dashcolor:'#707070',
                        trendscolor:'#707070',
                        toolscolor:'rgb(44, 11, 249)',
                        helpcolor:'#707070',
                        profilecolor:'#707070',
                      })
                        this.props.UnipayParentCallback("sale");
                    }
                    help =() =>{
                      this.setState({
                  
                        dashcolor:'#707070',
                        trendscolor:'#707070',
                        toolscolor:'#707070',
                        helpcolor:'rgb(44, 11, 249)',
                        profilecolor:'#707070',
                       })
                         this.props.UnipayParentCallback("transaction");
                    }
                    more =() =>{
                      this.setState(
                        { 

                        dashcolor:'#707070',
                        trendscolor:'#707070',
                        toolscolor:'#707070',
                        helpcolor:'#707070',
                        profilecolor:'rgb(44, 11, 249)',
                        Sidebar:true
                        })

                        this.props.UnipayParentCallback("more");

                    }

 render(){
    return (
      <>

         <div className="bottomnav-container mobile-primary-bar">
         <Link  to="/admin/dashboard" className="mobile-primary-bar__link" onClick={this.dash}>    
         <i className="pe-7s-graph3" aria-hidden="true" style={{width:'auto',fontSize:'35px',color:this.state.dashcolor}}></i>
               <p style={{color:this.state.dashcolor,fontSize:this.state.size,fontWeight:this.state.weight}}>Dashboard</p>
         </Link>

         <Link  to="/admin/settlement" className="mobile-primary-bar__link" onClick={this.trends}>    
         <i className="pe-7s-diskette" aria-hidden="true" style={{width:'auto',fontSize:'35px',color:this.state.trendscolor}}></i>
               <p style={{color:this.state.trendscolor,fontSize:this.state.size,fontWeight:this.state.weight}}>Settlement</p>
         </Link>  

         <Link  to="/admin/sale" className="mobile-primary-bar__link" onClick={this.tools}>    
         <i className="pe-7s-note2" aria-hidden="true" style={{width:'auto',fontSize:'35px',color:this.state.toolscolor}}></i>
                 <p style={{color:this.state.toolscolor,fontSize:this.state.size,fontWeight:this.state.weight}}>SALE</p>
         </Link>
         
         <Link  to="/admin/transaction-report" className="mobile-primary-bar__link" onClick={this.help}>
         <i className="pe-7s-news-paper" aria-hidden="true" style={{width:'auto',fontSize:'35px',color:this.state.helpcolor}}></i>
             <p style={{color:this.state.helpcolor,fontSize:this.state.size,fontWeight:this.state.weight}}>Transaction</p>
         </Link>
         
         <div className="mobile-primary-bar__link" onClick={this.more}>    
            <i className="pe-7s-menu" aria-hidden="true" style={{width:'auto',fontSize:'35px',color:this.state.profilecolor}} ></i>
               <p style={{color:this.state.profilecolor,fontSize:this.state.size,fontWeight:this.state.weight}}>More</p>
         </div>  
         </div>
         </>
         )
           }
}
const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(UnipayBar);